import { createContext } from 'react';
export const shoppingSessionContext = /*#__PURE__*/createContext({
  isLoaded: false,
  isLoading: false,
  shoppingContext: undefined
});
//# sourceMappingURL=shoppingSessionContext.js.map